

export const LOAD_USERS = "LOAD_USERS";
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const UPDATE_USER_FIELD = "UPDATE_USER_FIELD";
export const LOAD_USER_BY_ID = "LOAD_USER_BY_ID";
export const LOAD_USER_BY_ID_SUCCESS = "LOAD_USER_BY_ID_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_EXTERNAL_USER_SUCCESS = "UPDATE_EXTERNAL_USER_SUCCESS";
export const FILTER_USERS = "FILTER_USERS";
export const EMPTY_USER = "EMPTY_USER";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const ERROR_UPDATING_ROLE = "ERROR_UPDATING_ROLE";
export const SELECT_ALL_ROLES = "SELECT_ALL_ROLES";
export const SELECT_NO_ROLES = "SELECT_NO_ROLES";
export const SELECT_ALL_ROLES_IN_GROUP = "SELECT_ALL_ROLES_IN_GROUP";
export const SELECT_NO_ROLES_IN_GROUP = "SELECT_NO_ROLES_IN_GROUP";
export const LOAD_EXTERNAL_SUCCESS = "LOAD_EXTERNAL_SUCCESS";
export const LOAD_EXTERNAL_USER_BY_ID_SUCCESS = "LOAD_EXTERNAL_USER_BY_ID_SUCCESS";
export const OPTIONS_LOADED = "OPTIONS_LOADED";
export const OFFERS_LOADED = "OFFERS_LOADED";
export const LOADING_OPTIONS = "LOADING_OPTIONS";

export interface UsersState {
    loading: boolean
    loadingUser: boolean
    users: Array<User>
    usersFiltered: Array<User>
    editedUser: User | null
    externalUsers: Array<User>
    accountTypeOptions: { [key: string]: Array<any> },
    offersOptions?: { [key: string]: Array<any> },
    loadingOptions: boolean,
    error: string
}

export interface User {
    Username?: string
    email: string
    url: string
    phone_number: string
    phone_number_verified: boolean
    email_verified: boolean
    'custom:firstName'?: string
    'custom:lastName'?: string
    'custom:city'?: string
    'custom:state'?: string
    'custom:postalCode'?: string
    'custom:country'?: string
    'custom:role'?: string
    'custom:organization'?: string
    'custom:status'?: string
    temporary_password?: string
    'cognito:groups': Array<any>
    Enabled: boolean
    account_type?: string
    company?: string,
    'custom:account_type'?: {
        type: 'Client' | 'Affiliate' | 'Vendor',
        companies: {
            ta?: number[],
            lm?: number[],
            tg?: number[]
        },
        offers?: {
            ta?: number[],
            lm?: number[],
            tg?: number[]
        },
    }
}

export interface Category {
    id: number
    name: string
}


interface LoadUsers {
    type: typeof LOAD_USERS_SUCCESS | typeof LOAD_USERS | typeof LOAD_EXTERNAL_SUCCESS,
    payload: Array<User>
}

interface LoadUserById {
    type: typeof LOAD_USER_BY_ID_SUCCESS | typeof LOAD_USER_BY_ID | typeof LOAD_EXTERNAL_USER_BY_ID_SUCCESS,
    payload: User
}

interface UpdateUserField {
    type: typeof UPDATE_USER_FIELD,
    payload: {
        field: string
        value: string
    }
}

interface UpdateUser {
    type: typeof UPDATE_USER_SUCCESS | typeof UPDATE_EXTERNAL_USER_SUCCESS,
    payload: any
}

interface FilterUsers {
    type: typeof FILTER_USERS,
    payload: any
}

interface EmptyUser {
    type: typeof EMPTY_USER
}

interface UpdateRole {
    type: typeof UPDATE_ROLE
    payload: any
}

interface ErrorOnUpdate {
    type: typeof ERROR_UPDATING_ROLE,
    payload: string
}

interface BatchRolesUpdate {
    type: typeof SELECT_ALL_ROLES | typeof SELECT_NO_ROLES | typeof SELECT_ALL_ROLES_IN_GROUP | typeof SELECT_NO_ROLES_IN_GROUP
    payload: any
}

interface LoadOptions {
    type: typeof OPTIONS_LOADED | typeof LOADING_OPTIONS | typeof OFFERS_LOADED,
    payload: any
}

export type UserActionTypes = LoadOptions | LoadUsers | UpdateUserField | LoadUserById | LoadUsers | UpdateUser | FilterUsers | EmptyUser | UpdateRole | ErrorOnUpdate | BatchRolesUpdate;
